import { fetch } from '../plugins/ServicePlugin/plainService';
import Promise from 'when';
export const CALL_JSONAPI = Symbol('CALL JSONAPI SERVICE');
var error = require('debug')('svtse:middleware:jsonapi:error');

function callServiceCheck(res) {
	if (res.status >= 400) {
		const message = (res.body && res.body.errors)?res.body.errors.map((error) => (error.attributes || {}).message).join(', '):'Undefined request error';
		return Promise.reject({
			status: res.status,
			message: message,
			url: (res.request || {}).url
		});
	}
	return res;
}

function callServiceParse(res) {
	return res.json().then((data) => {
		data.meta = Object.assign({ 'cache-control': res.headers['cache-control']  }, data.meta);
		return data;
	});
}

function callService(host, endpoint, includes) {
	const fullUrl = calcFullUrl(host, endpoint, includes);
	return fetch(fullUrl)
		.then(callServiceCheck)
		.then(callServiceParse);
}

function calcFullUrl(host, endpoint, includes) {
	return (endpoint.indexOf(host) === -1 ? host + endpoint : endpoint) + ((includes && includes.length > 0)? '?include=' + [].concat(includes).sort().join(','):'');
}

const jsonapi = (store) => (next) => (action) => {
  const host = store.getState().getIn(['env', 'API'], '').replace(/\/+$/,'');
	const call = action[CALL_JSONAPI];
	if (typeof call === 'undefined') {
		return next(action);
	}

	const { types, endpoint, includes } = call;

	if (typeof endpoint !== 'string') {
		throw new Error('Specify a string endpoint URL.');
	}

	if (includes && !Array.isArray(includes) || Array.isArray(includes) && !includes.every((type) => typeof type === 'string')) {
		throw new Error('Expected an array of includes to be strings.');
	}

  if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected an array of three action types.');
	}

	if (!types.every((type) => typeof type === 'string')) {
		throw new Error('Expected action types to be strings.');
	}


	function actionWith(data) {
    const finalAction = Object.assign({}, action, data, {	endpoint: endpoint });
    delete finalAction[CALL_JSONAPI];
    return finalAction;
  }

	const [requestType, successType, failureType] = types;
	next(actionWith({ type: requestType }));

	return callService(host, endpoint, includes)
		.then((response) => next(actionWith({
			type: successType,
			payload: response,
			include: includes
		})))
		.catch((err) => {
				if (!err || !err.status || err.status >= 500) {
					error("Got an error when calling jsonapi %s, %o", calcFullUrl(host, endpoint, includes), err);
				}
				next(actionWith({
					type: failureType,
					error: err || 'Unknown error when calling the api'
				}));
			}
		);
};


export default jsonapi;




/** WEBPACK FOOTER **
 ** ./app/middleware/jsonapi.js
 **/